/* Stoned Crazy: free-shipping progress bar for the cart drawer and cart page.
   Threshold comes from the data attribute on the script tag.

   Host selection: several elements can match the host selector on the cart page
   (a cart-items-component plus one or more nested cart-summary wrappers), which
   would render the bar two or three times. So we keep only the OUTERMOST matches
   and then at most ONE per cart UI (the drawer and the cart page are separate
   UIs and may each show a bar). Any stray bar left over from a previous render
   is removed. */
(() => {
  const el = document.currentScript;
  const THRESHOLD = Number(el?.dataset.threshold || 0) * 100; // cents
  if (!THRESHOLD) return;

  const HOST_SELECTOR = 'cart-items-component, [class*="cart-summary"], [class*="cart__summary"]';

  const money = (cents) =>
    (cents / 100).toLocaleString(undefined, { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' });

  function pickHosts() {
    const all = Array.from(document.querySelectorAll(HOST_SELECTOR));
    // Drop any candidate that sits inside another candidate.
    const outermost = all.filter((node) => !all.some((other) => other !== node && other.contains(node)));
    // Then at most one per cart UI.
    const chosen = [];
    const seenScopes = new Set();
    for (const node of outermost) {
      const scope = node.closest('cart-drawer, dialog, #MainContent') || document.body;
      if (seenScopes.has(scope)) continue;
      seenScopes.add(scope);
      chosen.push(node);
    }
    return chosen;
  }

  function clearAll() {
    document.querySelectorAll('.sc-ship').forEach((bar) => bar.remove());
  }

  function render(total) {
    const left = THRESHOLD - total;
    const pct = Math.max(0, Math.min(100, (total / THRESHOLD) * 100));
    const done = left <= 0;
    const html = done
      ? '<div class="sc-ship__msg">You unlocked free US shipping</div>'
      : `<div class="sc-ship__msg">You're <b>${money(left)}</b> away from free US shipping</div>`;
    const markup = `${html}<div class="sc-ship__track"><div class="sc-ship__fill" style="width:${pct}%"></div></div>`;

    const kept = new Set();
    for (const host of pickHosts()) {
      let bar = host.querySelector(':scope > .sc-ship');
      if (!bar) {
        bar = document.createElement('div');
        bar.className = 'sc-ship';
        host.prepend(bar);
      }
      bar.classList.toggle('sc-ship--done', done);
      bar.innerHTML = markup;
      kept.add(bar);
    }
    // Remove duplicates or bars whose host is no longer the chosen one.
    document.querySelectorAll('.sc-ship').forEach((bar) => {
      if (!kept.has(bar)) bar.remove();
    });
  }

  let last = null;
  async function refresh() {
    try {
      const res = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
      if (!res.ok) return;
      const cart = await res.json();
      if (!cart.item_count) {
        last = null;
        clearAll();
        return;
      }
      // Re-render even when the total is unchanged if the bar is missing or duplicated,
      // which happens when the theme re-renders the cart section.
      if (cart.total_price === last && document.querySelectorAll('.sc-ship').length === pickHosts().length) return;
      last = cart.total_price;
      render(cart.total_price);
    } catch (e) {
      /* cart unavailable — show nothing rather than a wrong number */
    }
  }

  const kick = () => setTimeout(refresh, 150);
  document.addEventListener('DOMContentLoaded', kick);
  document.addEventListener('cart:update', kick);
  document.addEventListener('cart:refresh', kick);
  document.addEventListener('click', (e) => {
    if (e.target.closest('[href="/cart"], [class*="cart-icon"], [class*="add-to-cart"], form[action*="/cart/add"] button')) kick();
  });
  kick();
})();
